import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";
import { ImportParamItem, PrintTemplate } from "./types";

export const templateListService = (params: Types.TemplateListRequest) =>
  RestAPIClient.call<Types.TemplateListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });
export const templateListShortService = (params: Types.TemplateListRequest) =>
  RestAPIClient.call<Types.TemplateListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ListShort,
    config: {
      requireAuthentication: true,
      byPassError: true,
      params,
    },
  });

export const templateListByUserService = (params: Types.TemplateListRequest) =>
  RestAPIClient.call<Types.TemplateListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.Me,
    config: {
      requireAuthentication: true,
      byPassError: true,
      params,
    },
  });

export const templateCreateService = (params: Types.TemplateCreateRequest) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const templateDetailService = (id: string) =>
  RestAPIClient.call<Types.TemplateDetail>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const templateDetailFieldService = (
  id: string,
  params?: { templateFieldKeyword?: string }
) =>
  RestAPIClient.call<Types.TemplateDetail>({
    method: HTTPRequestMethods.GET,
    url: Paths.DetailField.replace("{id}", id),
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const templateDetailFieldMeService = (
  id: string,
  extend?: {
    year: number;
    month: number;
    cycleId: string;
    isGetCaptureTemplate: boolean;
  }
) =>
  RestAPIClient.call<Types.TemplateDetail>({
    method: HTTPRequestMethods.GET,
    url: Paths.DetailFieldMe.replace("{id}", id),
    config: {
      requireAuthentication: true,
      params: extend || {},
    },
  });

export const templateMeDetailService = (id: string) =>
  RestAPIClient.call<Types.TemplateDetail>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.MeDetail}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const templateUpdateService = (params: Types.TemplateUpdateRequest) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const templateDeleteService = (id: string) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.DELETE,
    url: `${Paths.Update}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const templateFieldUpdateService = ({
  templateId,
  id,
  status,
  index,
  columnName,
  columnNativeName,
  templateGroupFieldId,
  formula,
  glCode,
  isDataFromFile,
  isDisplay,
}: {
  templateId: string;
  id: string;
  status: number;
  index: number;
  columnName?: string;
  columnNativeName?: string;
  formula?: string;
  templateGroupFieldId?: string;
  glCode?: string;
  isDataFromFile?: boolean;
  isDisplay?: boolean;
}) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.UpdateField.replace("{id}", templateId).replace(
      "{fieldId}",
      id
    )}`,
    config: {
      requireAuthentication: true,
    },
    data: {
      status,
      index,
      columnNativeName,
      columnName,
      formula: { pattern: formula || "" },
      glCode,
      templateGroupFieldId,
      isDisplay: isDisplay || false,
      isDataFromFile: isDataFromFile || false,
    },
  });

export const templateFieldUpdateBulkService = ({
  templateId,
  items,
}: {
  templateId: string;

  items: {
    id: string;
    status: number;
    index: number;
    columnName?: string;
    columnNativeName?: string;
    formula?: { pattern: string };
    isDisplay?: boolean;
    glCode?: string;
    templateGroupFieldId?: string;
    isDataFromFile?: boolean;
  }[];
}) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.PUT,
    url: Paths.UpdateFieldBulk.replace("{id}", templateId),
    config: {
      requireAuthentication: true,
      byPassError: true,
    },
    data: {
      items,
    },
  });

export const templateGroupFieldUpdateService = ({
  id,
  templateId,

  columnNativeName,
  columnName,
  status,
  index,
}: {
  id: string;
  templateId: string;

  columnName?: string;
  columnNativeName: string;
  status: number;
  index: number;
}) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.PUT,
    url: Paths.GroupUpdateField.replace("{id}", templateId).replace(
      "{groupFieldId}",
      id
    ),
    config: {
      requireAuthentication: true,
    },
    data: {
      columnNativeName,
      columnName,
      status,
      index,
    },
  });

export const templateGroupFieldUpdateBulkService = ({
  templateId,
  items,
}: {
  templateId: string;

  items: {
    columnName?: string;
    columnNativeName: string;
    status: number;
    index: number;
    id: string;
  }[];
}) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.PUT,
    url: Paths.GroupUpdateFieldBulk.replace("{id}", templateId),
    config: {
      requireAuthentication: true,
    },
    data: {
      items,
    },
  });

export const templateFieldCreateService = ({
  templateId,
  index,
  fieldId,
  code,
  columnName,
  columnNativeName,
  dataType,
  groupData,
  formula,
  type,
  groupTransaction,
  isDataFromFile,
  glCode,
  isDisplay,
}: {
  templateId: string;
  index: number;
  fieldId: string;
  code: string;
  columnName: string;
  columnNativeName: string;
  dataType: number;
  groupData: string;
  groupTransaction?: string;
  formula?: string;
  glCode?: string;
  isDataFromFile?: boolean;
  type: number;
  isDisplay?: boolean;
}) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.CreateField.replace("{id}", templateId),
    config: {
      requireAuthentication: true,
    },
    data: {
      index,
      fieldId,
      code,
      columnName,
      columnNativeName,
      dataType,
      groupData,
      type,
      groupTransaction,
      isDataFromFile,
      glCode,
      isDisplay,
      ...(formula && {
        formula: {
          pattern: formula,
        },
      }),
    },
  });

export const templateGroupFieldCreateService = ({
  id,
  ...rest
}: {
  id: string;
  code: string;
  columnName?: string;
  columnNativeName?: string;
  productivityTemplateFieldIds?: string[];
}) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.CreateGroupField.replace("{id}", id),
    config: {
      requireAuthentication: true,
    },
    data: rest,
  });

export const templateFieldDeleteService = ({
  id,
  fieldId,
}: {
  id: string;
  fieldId: string;
}) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.DELETE,
    url: Paths.DeleteField.replace("{id}", id).replace("{fieldId}", fieldId),
    config: {
      requireAuthentication: true,
    },
  });

export const templateGroupFieldDeleteService = ({
  id,
  groupFieldId,
}: {
  id: string;
  groupFieldId: string;
}) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.DELETE,
    url: Paths.DeleteGroupField.replace("{id}", id).replace(
      "{groupFieldId}",
      groupFieldId
    ),
    config: {
      requireAuthentication: true,
    },
  });

export const importFieldListService = ({
  templateId,
}: {
  templateId: string;
}) =>
  RestAPIClient.call<
    RestAPIResponseList<{
      id: string;
      code: string;
      columnName: string;
      columnNativeName: string;
      groupData: string;
      groupTransaction: string;
      dataType: number;
      templateGroupField: {
        id: string;
        code: string;
        columnName: string;
        columnNativeName: string;
      };
    }>
  >({
    method: HTTPRequestMethods.GET,
    url: Paths.ImportFieldList,
    config: {
      requireAuthentication: true,
      params: { templateId },
    },
  });

export const importParamListService = ({
  templateId,
  cycleId,
  year,
  month,
  page,
  limit,
}: {
  page?: number | null;
  limit?: number | null;
  year: number;
  month: number;
  templateId: string;
  cycleId: string;
}) =>
  RestAPIClient.call<RestAPIResponseList<ImportParamItem>>({
    method: HTTPRequestMethods.GET,
    url: Paths.ImportParamList,
    config: {
      requireAuthentication: true,
      params: {
        templateId,
        cycleId,
        year,
        month,
        page,
        limit,
      },
    },
  });

export const importParamImportService = ({
  year,
  month,
  templateId,
  cycleId,
  items,
}: {
  year: number;
  month: number;
  templateId: string;
  cycleId: string;
  items: {
    empId: number;
    empCode: string;
    empFullname: string;
    code: string;
    dataType: number;
    value: number | string;
  }[];
}) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.ImportParamImport,
    config: {
      requireAuthentication: true,
    },
    data: {
      year,
      month,
      templateId,
      cycleId,
      items,
    },
  });

export const printTemplateListService = ({
  templateId,
  page,
  limit,
  id,
  status,
  keyword,
  select,
}: {
  templateId: string;
  page?: number | null;
  limit?: number | null;
  id?: string | null;
  status?: number | null;
  keyword?: string | null;
  select?: string[] | null;
}) =>
  RestAPIClient.call<RestAPIResponseList<PrintTemplate>>({
    method: HTTPRequestMethods.GET,
    url: Paths.PrintTemplateList,
    config: {
      requireAuthentication: true,
      params: {
        page,
        limit,
        id,
        status,
        keyword,
        select,
        templateId,
      },
    },
  });

export const printTemplateCreateService = ({
  name,
  nativeName,
  description,
  nativeDescription,
  fileName,
  templateId,
  groupBy,
}: {
  name?: string;
  nativeName: string;
  description?: string;
  nativeDescription: string;
  templateId: string;
  fileName: string;
  groupBy?: string;
}) =>
  RestAPIClient.call<PrintTemplate>({
    method: HTTPRequestMethods.POST,
    url: Paths.PrintTemplateCreate,
    config: {
      requireAuthentication: true,
    },
    data: {
      name,
      nativeName,
      description,
      nativeDescription,
      fileName,
      templateId,
      groupBy,
    },
  });

export const printTemplateUpdateService = ({
  printTemplateId,
  name,
  description,
  fileName,
  nativeName,
  nativeDescription,
  groupBy,
}: {
  name?: string;
  nativeName: string;
  description?: string;
  nativeDescription: string;
  fileName: string;
  printTemplateId: string;
  groupBy?: string;
}) =>
  RestAPIClient.call<PrintTemplate>({
    method: HTTPRequestMethods.PUT,
    url: Paths.PrintTemplateUpdate.replace("{id}", printTemplateId),
    config: {
      requireAuthentication: true,
    },
    data: {
      name,
      description,
      fileName,
      nativeName,
      nativeDescription,
      groupBy,
    },
  });

export const printTemplateDetailService = (printTemplateId: string) =>
  RestAPIClient.call<PrintTemplate>({
    method: HTTPRequestMethods.GET,
    url: Paths.PrintTemplateDetail.replace("{id}", printTemplateId),
    config: {
      requireAuthentication: true,
    },
  });

export const printTemplateDeleteService = (printTemplateId: string) =>
  RestAPIClient.call<PrintTemplate>({
    method: HTTPRequestMethods.DELETE,
    url: Paths.PrintTemplateDelete.replace("{id}", printTemplateId),
    config: {
      requireAuthentication: true,
    },
  });

export const templateFieldHistoryListService = ({
  templateId,
  templateFieldId,
  page,
  limit,
}: Types.TemplateFieldHistoryListRequest) =>
  RestAPIClient.call<{ items: Types.TemplateFieldHistory[]; total: number }>({
    method: HTTPRequestMethods.GET,
    url: Paths.FieldHistoryList.replace("{id}", templateId),
    config: {
      requireAuthentication: true,
      params: {
        templateFieldId: templateFieldId || undefined,
        page: page || 1,
        limit: limit || 20,
      },
    },
  });
